import React, { useState } from "react";
import "./ServiceDev.css";
import { Icon } from "@iconify/react";
import SoftwareServiceBannerImg from "../../../Assets/Images/Software-Development_Service_banner/Image.png";
import { Link } from "react-router-dom";

const ServiceDevBanner = () => {
  const [buttonText, setButtonText] = useState("Get in Touch");

  const handleMouseEnter = () => {
    setButtonText("Contact Us ");
  };

  const handleMouseLeave = () => {
    setButtonText("Get in Touch");
  };

  return (
    <div className="service-dev-banner-section container">
      <div className="row align-items-center p-3">
        <div className="col-lg-6">
          <h1 className="service-dev-title mb-4">
            Custom Software <br />
            Development Built Around Reality
          </h1>
          <p className="service-dev-text">
            Most businesses do not need more software. They need the right
            software. Our custom software development services are focused on
            creating systems that mirror the way your teams really work, adapt
            as your needs change and support long term growth without too much
            complexity or wasted effort.
          </p>

          <div className="features-list row">
            <div className="col-6 col-lg-6 ">
              <p>
                <Icon
                  className="service-check"
                  icon="lucide:circle-check-big"
                />
                Software consulting
              </p>
              <p>
                <Icon
                  className="service-check"
                  icon="lucide:circle-check-big"
                />
                Mobile App Development
              </p>
              <p>
                <Icon
                  className="service-check"
                  icon="lucide:circle-check-big"
                />
                Database Development
              </p>
              <p>
                <Icon
                  className="service-check"
                  icon="lucide:circle-check-big"
                />
                SaaS Product Development
              </p>
              <p className="single-line">
                <Icon
                  className="service-check"
                  icon="lucide:circle-check-big"
                />
                API Development and Software Integration
              </p>
            </div>

            <div className="col-6 col-lg-6">
              <p>
                <Icon
                  className="service-check"
                  icon="lucide:circle-check-big"
                />
                Web Application Development
              </p>
              <p>
                <Icon
                  className="service-check"
                  icon="lucide:circle-check-big"
                />
                Desktop App Development
              </p>
              <p>
                <Icon
                  className="service-check"
                  icon="lucide:circle-check-big"
                />
                Cloud Based Development
              </p>
              <p>
                <Icon
                  className="service-check"
                  icon="lucide:circle-check-big"
                />
                Software Upgrading
              </p>
            </div>
          </div>

          <Link
            to="/contact-us/build-business"
            style={{ textDecoration: "none" }}
          >
            <button
              className="btn get-touch-btn mt-4"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {buttonText}
            </button>
          </Link>
        </div>

        <div className="col-lg-6">
          <img
            className="service-dev-img img-fluid"
            src={SoftwareServiceBannerImg}
            alt="service-banner"
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceDevBanner;
